"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgInsurance = function SvgInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 5.5s.324 11.405 7.938 14.78c7.968-3.375 7.42-15.086 7.42-15.086s-4.697-.206-6.095-1.302c-1.397-1.097-1.594-1.278-2.865 0C9.127 5.17 4 5.499 4 5.499z",
    stroke: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.803 8.478v6.363m-3.078-3.295h6.237",
    stroke: "#17181A"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgInsurance);
var _default = Memo;
exports["default"] = _default;